import { render } from "./leftblock.vue?vue&type=template&id=58c72e6b"
import script from "./leftblock.vue?vue&type=script&lang=js"
export * from "./leftblock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__